import { render, staticRenderFns } from "./SlidingSideMenu.vue?vue&type=template&id=b5e967dc&scoped=true&"
import script from "./SlidingSideMenu.vue?vue&type=script&lang=js&"
export * from "./SlidingSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./SlidingSideMenu.vue?vue&type=style&index=0&id=b5e967dc&prod&scoped=true&lang=scss&"
import style1 from "./SlidingSideMenu.vue?vue&type=style&index=1&id=b5e967dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e967dc",
  null
  
)

export default component.exports